import { makeStyles } from '@mui/styles';
import type { Theme } from '@mui/material/styles';
import { grey } from '@mui/material/colors';

export const useStyles = makeStyles<Theme>(({ drawerWidth, spacing, palette: { primary, getContrastText } }) => {
  const sidebarBgColor = grey[900];

  return {
    drawer: {
      backgroundColor: sidebarBgColor,
      color: getContrastText(sidebarBgColor),
    },
    loadingWrapper: {
      display: 'flex',
      height: '100%',
      overflow: 'hidden',
      alignItems: 'center',
      justifyContent: 'center',
    },
    list: {
      overflow: 'auto',
      flex: 1,
      width: drawerWidth,
      height: '100%',
      zIndex: 4,
    },
    item: {
      transition: 'all 150ms linear',
      margin: spacing(1),
      padding: spacing(1, 2),
      borderRadius: 3,
      width: 'auto',
      '&:hover, &:focus': {
        color: primary.contrastText,
        backgroundColor: primary.dark,
      },
    },
    itemActive: {
      color: primary.contrastText,
      backgroundColor: primary.main,
      boxShadow: 'none',
    },
    itemIcon: {
      color: 'inherit',
    },
    itemText: {
      color: 'inherit',
    },
    logo: {
      position: 'relative',
      padding: '15px 25px',
      zIndex: 4,
      margin: '20px 0 0 0',
    },
    logoText: {
      fontSize: 18,
    },
  };
});
